import { createAction } from 'redux-actions';

export const IS_LOADING = 'IS_LOADING';
export const UPDATE_STANDALONE_CONTENTS = 'UPDATE STANDALONE CONTENTS';
export const UPDATE_CALENDAR_TYPES = 'UPDATE CALENDAR TYPES';
export const UPDATE_TWO_UP_SECTION = 'UPDATE TWO UP SECTION';
export const UPDATE_MARQUEE_SIDE_PANEL_DETAILS = 'UPDATE MARQUEE SIDE PANEL DETAILS';
export const UPDATE_CALENDAR_TYPES_SECTION_HEADINGS = 'UPDATE CALENDAR TYPES SECTION HEADINGS';

const isLoading = createAction(
    IS_LOADING,
    isLoading => isLoading
);

const updateStandaloneConents = createAction(
    UPDATE_STANDALONE_CONTENTS,
    standaloneContents => standaloneContents
);

const updateCalendarTypes = createAction(
    UPDATE_CALENDAR_TYPES,
    calendarTypes => calendarTypes
);

const updateTwoUpSection = createAction(
    UPDATE_TWO_UP_SECTION,
    twoUpSectionData => twoUpSectionData
);

const updateMarqueeSidePanelDetails = createAction(
    UPDATE_MARQUEE_SIDE_PANEL_DETAILS,
    marqueeSidePanelData => marqueeSidePanelData
);

const updateCalendarTypesSectionHeadings = createAction(
    UPDATE_CALENDAR_TYPES_SECTION_HEADINGS,
    calendarTypesSectionHeadings => calendarTypesSectionHeadings
);

export {
    isLoading,
    updateStandaloneConents,
    updateCalendarTypes,
    updateTwoUpSection,
    updateMarqueeSidePanelDetails,
    updateCalendarTypesSectionHeadings
};
